import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../hooks/use-auth";
import { cn } from "../lib/utils";
import { Button } from "../components/ui/button";
import { updateUserLastLoginWithAdmin } from "../lib/actions";
import { navItems } from "../lib/nav-items";
import { PAUSED_PATHS, isLimitedByPause } from "../lib/subscription";
import { INACTIVE_PATHS, isBlockedForInactivity } from "../lib/inactivity";


export default function DesktopNav() {
  const location = useLocation();
  const pathname = location.pathname;
  const { user, unreadChatCount, tourStep, setTourStep } = useAuth();
  
  const handleChatClick = async () => {
    if (user) {
      if (tourStep === 'chat_icon') {
        setTourStep('ursa_chat');
      }
      try {
        await updateUserLastLoginWithAdmin(user.id);
      } catch (error) {
        console.error("Failed to update last login time:", error);
      }
    }
  };
  
  if (!user) {
    return null;
  }
  
  const allowedPaths = isLimitedByPause(user)
    ? PAUSED_PATHS
    : isBlockedForInactivity(user)
      ? INACTIVE_PATHS
      : null;
  const accessibleNavItems = navItems.filter(
    (item) => item.roles.includes(user.role) && (!allowedPaths || allowedPaths.includes(item.href))
  );

  return (
    <nav className="flex items-center gap-1 md:gap-2">
      {accessibleNavItems.map((item) => {
        const isActive = pathname.startsWith(item.href);
        const isChat = item.href === '/chat';
        const isProfile = item.href === '/profile';
        
        let isHighlighted = false;
        if (isChat && tourStep === 'chat_icon') isHighlighted = true;
        if (isProfile && tourStep === 'profile_icon') isHighlighted = true;

        
        const buttonProps = {
          onClick: () => {
            if (isChat) handleChatClick();
            if (isProfile && tourStep === 'profile_icon') setTourStep('uredi_profil_button');
          }
        };

        return (
          <Button 
            asChild 
            variant={isActive ? "nav-active" : "nav"} 
            key={item.href} 
            size="icon" 
            className={cn("relative", isHighlighted && "animate-pulse-strong")}
            >
              <Link
                  to={item.href}
                  className="flex items-center gap-2 font-black"
                  onClick={buttonProps.onClick}
              >
                  <item.icon className={cn("h-5 w-5")} fill="currentColor" />
                  {isChat && unreadChatCount > 0 && (
                    <span className="absolute -top-1 -right-1 flex h-4 w-4 items-center justify-center rounded-full bg-red-500 text-xs font-bold text-white">
                        {unreadChatCount}
                    </span>
                  )}
              </Link>
          </Button>
        );
      })}
    </nav>
  );
}
